import { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

export interface InfoCardProps {
    icon: ReactNode;
    title: string;
    children: ReactNode;
    cta?: ReactNode;
}

const InfoCard: FunctionComponent<InfoCardProps> = ({ icon, title, children, cta }) => (
    <Card>
        <Header>
            <IconContainer aria-hidden="true">{icon}</IconContainer>
            <Title>{title}</Title>
        </Header>
        <Divider />
        <Content>{children}</Content>
        {cta != null && (
            <Footer>
                <Divider />
                <Actions>{cta}</Actions>
            </Footer>
        )}
    </Card>
);

const Card = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 460px;
    max-width: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: ${props => props.theme.colors.background};
    border-radius: 8px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.10);
    border-top: 4px solid ${props => props.theme.colors.highlight};
    cursor: default;

    p {
        margin: 0;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 12px;
    border-radius: 8px;
    color: ${props => props.theme.colors.highlight};
    background-color: ${props => props.theme.colors.highlightLight};

    svg {
        height: 24px;
        width: 24px;
    }
`;

const Title = styled.h1`
    font-size: 18px;
    font-weight: 600;
    margin: 0;
`;

const Divider = styled.div`
    height: 2px;
    width: 100%;
    background-color: ${props => props.theme.colors.backgroundPaper};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
`;

const Footer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const Actions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 32px;
    gap: 12px;
`;

export default InfoCard;
